import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  NavigationExtras,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    public auth: AuthenticationService,
    public router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const navigationExtras: NavigationExtras = {
      queryParams: { return: state.url },
      queryParamsHandling: 'merge',
    };
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['login'], navigationExtras);
      return false;
    }
    return true;
  }
}
